import styled from '@emotion/styled';
import Page from '../../layout/Page';
import Price from '../main/price/price';
// import First from './first';
// import Second from "./second";
// import Third from './third';
// import Fourth from './fourth';
// import Fifth from './fifth';

const Subscribe:React.FC<any> = () => {
  return (
    <Page disable>
      <Conatiner>
        {/* <Title>
          가장 편하게 
          <br/>인화 앨범을 만드세요
        </Title>
        <ImgContainer>
          <Img src="/images/klikkie/main/subs.png"/>
        </ImgContainer> */}
        {/* <First />
        <Second />
        <Video></Video>
        <Third />
        <ImgContainer className="top"></ImgContainer>
        <Fourth />
        <Fifth /> */}
        <Price />
      </Conatiner>
    </Page>
  )
}

export default Subscribe;

const Conatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 131px;
`;

const Video = styled.div`
  width: 100%;
  background-color: #CBCAE1;
  min-height: 400px;
`;

const ImgContainer = styled.div`
  width: 100%;
  min-height: 400px;

  &.top {
    background-color: #F0FDE9;
  }
`
const Img = styled.img`
  width: 100%;
`

const Title = styled.div`
  display: flex;
  width: 100%;
  /* height: 70px; */
  font-size: 18px;
  margin-left: 16px;
  margin-top: 60px;
  margin-bottom: 25px;
  font-size: 24px;
  font-weight: bold;
  /* align-items: center; */
  /* justify-content: center; */

  span {
    font-weight: 700;
  }
`;
